import AdminConfigHealth from "./AdminConfigHealth";
export default AdminConfigHealth;
